var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomer360(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#445062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer360",
    transform: "translate(-16 -320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(20.6 323.667)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "user-2",
    "data-name": "user",
    d: "M12,11.5v-1A2.5,2.5,0,0,0,9.5,8h-4A2.5,2.5,0,0,0,3,10.5v1a.5.5,0,1,0,1,0v-1A1.5,1.5,0,0,1,5.5,9h4A1.5,1.5,0,0,1,11,10.5v1a.5.5,0,0,0,1,0Zm-2-7a2.5,2.5,0,1,0-.732,1.768A2.5,2.5,0,0,0,10,4.5Zm-1,0A1.5,1.5,0,1,1,8.56,3.439,1.493,1.493,0,0,1,9,4.5Z",
    transform: "translate(-3 -2)",
    stroke: "#05152d",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(16 320)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "search-2",
    "data-name": "search",
    d: "M16.041,15.856a.994.994,0,0,0-.1.087,1.01,1.01,0,0,0-.087.1,7,7,0,1,1,.186-.186Zm5.666,4.437-3.675-3.675a9,9,0,1,0-1.414,1.414l3.675,3.675a1,1,0,0,0,1.414-1.414Z",
    transform: "translate(-2 -2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer360);
export default __webpack_public_path__ + "static/media/customer360.ef4a3365114304bae9abf4ec73087766.svg";
export { ForwardRef as ReactComponent };